export default "__VITE_ASSET__DSuX55tf__"